// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o5Kwh","importantInfo":"styles_importantInfo__-MSh4"};